import React from "react";

import { Tooltip } from 'react-tooltip'
import { InformationCircleIcon } from "@heroicons/react/24/outline";

class Question extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isFirst: false
    }
  }


  componentDidMount() {
    this.setState({ error: null, isFirst: false })
    if (this.props.pressSubmitOnce) {
      var o = {}
      o[this.props.name] = this.props.value
      this.props.schema.validateAt(this.props.name, o).catch(e => {
        this.setState({ error: e.errors[0] })
      })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.value !== this.props?.value || prevProps.pressSubmitOnce !== this.props.pressSubmitOnce) {
      this.setState({ error: null, isFirst: false })
      if (this.props.pressSubmitOnce) {
        var o = {}
        o[this.props.name] = this.props.value
        this.props.schema.validateAt(this.props.name, o).catch(e => {
          this.setState({ error: e.errors[0] })
        })
      }
    }
  }

  render() {
    return !this.props.hidden && (
      <div className={`mb-4${this.props.className ? ` ${this.props.className}` : ""}`}>
        <div className={this.state.error ? "font-medium text-[13px] text-red-600 flex items-center gap-1 mb-1.5" : "text-[13px] font-medium flex items-center gap-1 mb-1.5"} style={!this.state.error ? { color: '#3a4250' } : {}}><span lang="fr" translate="yes">{this.props.title}</span> {this.props.required ? <span className="text-red-500">*</span> : ""} {this.props.tooltip ? <>
          <div data-tooltip-id={"tooltip_" + this.props.id} data-tooltip-content={this.props.tooltip}>
            <InformationCircleIcon className="h-4" />
          </div>
          <Tooltip id={"tooltip_" + this.props.id}><span lang="fr" translate="yes">{this.props.tooltip}</span></Tooltip>
        </> : null}
        </div>
        {this.props.description && <div className="text-xs text-gray-400 mb-1"><span lang="fr" translate="yes">{this.props.description}</span></div>}
        {this.state.error && <div className="text-xs text-red-500 mt-1">{this.state.error}</div>}
        {this.props.children ?
          (this.props.children(this.state.error) ? this.props.children(this.state.error) : <></>) :
          <></>}
      </div>
    );
  }
}

export default Question;